<app-base-modal
  [gradientBackground]="'linear-gradient(to bottom, var(--color-camellia), var(--color-sundown))'"
  [hasCustomHeader]="true"
  size="wide"
  height="tall"
  (closed)="close()"
>
  <div header class="super-stars-header">
    <div class="header-row">
      <img
        src="assets/score/super-star-doodat.png"
        alt=""
        aria-hidden="true"
        class="header-mascot"
      />
      <h2 class="header-title">your super stars</h2>
    </div>
    <div class="stars-description">
    <p>
      <strong>These are the Stars that seem to help, time and time again.</strong>
    </p>
    <p >
      These are the Stars you've scored most strongly over time. Tap any Star
      to add it to today's score.</p>
    <p>
      <strong><em>Could any of these Stars find a place in today's plan?</em></strong>
    </p>
  </div>
  </div>

  
  <div class="stars-list">
    <app-star-line-item
      *ngFor="let star of stars"
      [name]="star"
      (clicked)="closeWithStar(star)"
    ></app-star-line-item>
  </div>
</app-base-modal>
